import { render, staticRenderFns } from "./JobSearchList.vue?vue&type=template&id=87f7ef3a&scoped=true&"
import script from "./JobSearchList.vue?vue&type=script&lang=ts&"
export * from "./JobSearchList.vue?vue&type=script&lang=ts&"
import style0 from "./JobSearchList.vue?vue&type=style&index=0&id=87f7ef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f7ef3a",
  null
  
)

export default component.exports